<template>
  <b-tabs>
    <b-tab>
      <b-list-group class="list-group-accent">
        <b-list-group-item
          class="bg-light text-center font-weight-bold text-muted text-uppercase small"
        >Elementos de Formato</b-list-group-item>
      </b-list-group>
      <b-list-group-item
        id="listContenedores"
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        @click="addColumns(2)"
        :disabled="flagBlocks.bF || inPreview"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="columns" />&nbsp; Dos Columnas
            </a>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group-item
        id="listContenedores"
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        @click="addColumns(3)"
        :disabled="flagBlocks.bF || inPreview"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="th" />&nbsp; Tres Columnas
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group-item
        id="listTexto"
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        @click="addElement('subtitulo')"
        :disabled="flagBlocks.bF || inPreview"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="grip-lines" />&nbsp; Subtítulo
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group-item
        id="listTexto"
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        @click="addElement('separator')"
        :disabled="flagBlocks.bF || inPreview"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="minus" />&nbsp; Separador
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group class="list-group-accent">
        <b-list-group-item
          class="bg-light text-center font-weight-bold text-muted text-uppercase small"
        >Elementos de Texto</b-list-group-item>
      </b-list-group>

      <b-list-group-item
        id="listTexto"
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        @click="addElement('texto')"
        :disabled="inPreview"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="align-justify" />&nbsp; Párrafo
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group-item
        id="listTexto"
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        @click="addElement('tabla')"
        :disabled="inPreview"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="table" />&nbsp; Tabla
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group class="list-group-accent">
        <b-list-group-item
          class="bg-light text-center font-weight-bold text-muted text-uppercase small"
        >Elementos Multimedia</b-list-group-item>
      </b-list-group>
      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        @click="addElement('imagen')"
        :disabled="inPreview"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="image" />&nbsp; Imagen
            </a>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="inPreview"
        @click="addElement('video')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="film" />&nbsp; Video
            </a>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="inPreview"
        @click="addElement('audio')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="volume-down" />&nbsp; Audio
            </a>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group class="list-group-accent">
        <b-list-group-item
          class="bg-light text-center font-weight-bold text-muted text-uppercase small"
        >Actividades</b-list-group-item>
      </b-list-group>

      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('flashcards')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="adjust" />&nbsp; Flashcards
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('memorama')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="brain" />&nbsp; Memorama
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <!--<b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('hangman')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="male" />&nbsp; &nbsp; Ahorcado
            </a>
          </li>
        </ul>
      </b-list-group-item>-->

      <!--<b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('animales')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="paw" />&nbsp; Animales
            </a>
          </li>
        </ul>
      </b-list-group-item>-->

      <!--<b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('loteria')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="th" />&nbsp; Loteria
            </a>
          </li>
        </ul>
      </b-list-group-item>-->

      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('relacionar')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="link" />&nbsp; Relacionar Palabras
            </a>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('completarFrase')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="ad" />&nbsp; Completa la lectura
            </a>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('crucigrama')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="border-none" />&nbsp; Crucigrama
            </a>
          </li>
        </ul>
      </b-list-group-item>
      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('sopa')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="crop-alt" />&nbsp; Sopa de letras
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('dot')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="draw-polygon" />&nbsp; Punto a punto
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <b-list-group-item
        href="#"
        class="list-group-item-accent-info list-group-item-divider"
        :disabled="flagBlocks.bF || inPreview"
        @click="addElement('quizz')"
      >
        <ul class="nav actividad-list-elementos">
          <li class="nav-item">
            <a class="nav-link">
              <font-awesome-icon icon="tasks" />&nbsp; Quiz
            </a>
          </li>
        </ul>
      </b-list-group-item>

      <!--<b-list-group class="list-group-accent">
        <b-list-group-item
          class="bg-light text-center font-weight-bold text-muted text-uppercase small"
        >Evaluaciones</b-list-group-item>
      </b-list-group>-->
    </b-tab>
  </b-tabs>
</template>

<script>
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}
import Vue from "vue";
export default {
  name: "ConstructorAside",
  data() {
    return {
      //order: this.$store.getters["constructor/getActualOrder"] || 0,
      //numberColumns: 2,
      confElement: {
        columnas: {
          index: null,
          tag: "Columnas",
          columns: []
        },
        subtitulo: {
          index: null,
          tag: "Subtitulo",
          content: "",
          config: { color: "#ffffff", backgroundColor: "#1ba1e2" }
        },
        separator: {
          index: null,
          tag: "Separator",
          content: ""
        },
        texto: {
          index: null,
          tag: "Parrafo",
          content: ""
        },
        tabla: {
          index: null,
          tag: "Tabla",
          content: ""
        },
        imagen: {
          index: null,
          tag: "Recurso",
          type: "IMAGEN",
          file: null,
          link: null
        },
        video: {
          index: null,
          tag: "Recurso",
          type: "VIDEO",
          file: null,
          link: null
        },
        audio: {
          index: null,
          tag: "Recurso",
          type: "AUDIO",
          file: null,
          link: null
        },
        flashcards: {
          index: null,
          tag: "FlashCards",
          elementos: [],
          instrucciones: ""
        },
        memorama: {
          index: null,
          tag: "Memorama",
          elementos: [],
          instrucciones: ""
        },
        hangman: {
          index: null,
          tag: "HangMan",
          palabras: [],
          instrucciones: ""
        },
        animales: {
          index: null,
          tag: "Animales",
          instrucciones: ""
        },
        loteria: {
          index: null,
          tag: "Loteria",
          instrucciones: ""
        },
        relacionar: {
          index: null,
          tag: "RelacionarContent",
          elementos: [],
          instrucciones: ""
        },
        completarFrase: {
          index: null,
          tag: "CompletarFrase",
          instrucciones: "",
          lectura: ""
        },
        crucigrama: {
          index: null,
          tag: "Crucigrama",
          palabras: [],
          instrucciones: "",
          horizontal: null,
          vertical: null
        },
        sopa: {
          index: null,
          tag: "Sopa",
          palabras: [],
          instrucciones: "",
          size: null
        },
        dot: {
          index: null,
          tag: "Dot",
          instrucciones: "",
          points: [],
          file: null
        },
        quizz: {
          index: null,
          tag: "QuizContent",
          preguntas: [],
          instrucciones: ""
        }
        /*ordenafrase: {
          index: null,
          tag: "OrdenaFrase",
          elementos: [],
          instrucciones: ""
        }*/
      }
    };
  },
  methods: {
    addElement(element) {
      var dom = this.confElement[element];
      dom.id = uuidv4();
      let elementSelected = JSON.parse(JSON.stringify(dom));
      //console.log("Click: ", dom);
      if (this.flagBlocks.bS) {
        //console.log("in block");
        this.$store.dispatch(
          "constructor/insertElementInBlock",
          elementSelected
        );
      } else {
        //console.log("no block");
        this.$store.dispatch("constructor/insertElement", elementSelected);
      }
    },
    addColumns(number) {
      this.confElement.columnas.columns = this.setNumberOfColumns(number);
      this.addElement("columnas");
    },
    setNumberOfColumns(number) {
      let array = [];
      for (var i = 0; i < number; i++) {
        array.push({
          selected: false,
          element: null
        });
      }
      return array;
    }
  },
  computed: {
    flagBlocks() {
      return this.$store.getters["constructor/getFlagsAboutBlocks"];
    },
    getPositionBlockSelected() {
      return this.$store.getters["constructor/getPositionBlockSelected"];
    },
    inPreview() {
      return this.$store.getters["constructor/getFlagPreview"];
    }
  }
};
</script>

<style lang="scss" scoped>
.list-group-item.disabled,
.list-group-item:disabled {
  background-color: #eee !important;
}
</style>